import Classnames from "classnames";
import { useState } from "react";

import Link from "@router/link";
import Button from "@shared/button";
import ConsentDocuments from "@shared/consent-documents";
import LanguageToggle from "@shared/language-toggle";
import AlertStore from "@utils/alert/store";
import { useSignout, useTermsAccept, useTermsMe } from "@utils/api/queries";
import i18n, { loadTranslations } from "@utils/i18n";
import { Language } from "@utils/types";

import trackLogo from "../../../assets/images/tracklogo_text.svg";
import translations from "../../translations/re-consent-page.lang.yaml";
import style from "./re-consent-page.styl";

loadTranslations(translations, "reConsentPage");

const ReConsentPage = () => {
  const {
    terms = [],
    isLoading: isTermsLoading,
    isError: isTermsError,
  } = useTermsMe({ language: i18n.language as Language });

  const { mutate: postTermsAccept } = useTermsAccept();

  const { mutate: postSignout } = useSignout();

  const [agreed, setAgreed] = useState(false);

  const onLogout = () => {
    postSignout(undefined, {
      onSuccess: () => {
        AlertStore.clearAlerts();
        window.location.reload();
      },
    });
  };

  const onAgree = () => {
    const termsIds = terms.map((term) => term.id);

    postTermsAccept(
      { termsIds },
      {
        onSuccess: (data) => {
          AlertStore.clearAlerts();
          if (data?.redirectUrl) {
            window.location.href = data.redirectUrl;
          }
        },
      },
    );
  };

  return (
    <div className={Classnames("gradientBackground", style.page)}>
      <div className={style.scrollContainer}>
        <div className={style.languageToggleContainer}>
          <LanguageToggle />
        </div>
        <div className={style.container}>
          <div className={style.header}>
            <img src={trackLogo} className={style.headerLogo} />
            <h2 className="strongBody mediumDark">
              {i18n.t("reConsentPage:title")}
            </h2>
            <p className="smallCopy dark">
              {i18n.t("reConsentPage:description")}
            </p>
          </div>
          <ConsentDocuments
            documents={terms}
            title={i18n.t("reConsentPage:documents")}
            agreementTitle={i18n.t("reConsentPage:agreement")}
            isLoading={isTermsLoading}
            isError={isTermsError}
            onAgreedChange={setAgreed}
          />
          <div className={style.actionContainer}>
            <Button
              fill
              disabled={!agreed}
              onClick={onAgree}
              data-testid="button-re-consent-agree"
            >
              {i18n.t("reConsentPage:agreeButton")}
            </Button>
            <p className={Classnames("smallCopy dark", style.notAgreeText)}>
              {i18n.t("reConsentPage:notAgreePrefix")}
              <Link
                href="#"
                onClick={onLogout}
                className="primary"
                data-testid="link-re-consent-logout"
              >
                {i18n.t("reConsentPage:logout")}
              </Link>
              {i18n.t("reConsentPage:notAgreeSuffix")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReConsentPage;
